import { createColumnHelper } from '@tanstack/react-table';
import { Sample } from '@texas/api/endpoints/samplesApi';
import {
  sampleColumnsCreator,
  SamplesColumnsBaseProps,
} from './sampleColumnsCreator';
import { formatDate } from '@texas/utils/helpers/dateHelper';
import { Locale } from '@texas/i18n/types';

export const samplesInititatedColumns = (props: SamplesColumnsBaseProps) => {
  const columnHelper = createColumnHelper<Sample>();
  const columns = [
    columnHelper.accessor('sampleInitiatedDate', {
      cell: (info) => formatDate(Locale.En, info.getValue()),
      header: props.t('sample.initiated'),
      meta: { toggleable: true, defaultVisible: true },
    }),
    columnHelper.accessor('sampleReadyDate', {
      cell: (info) =>
        info.getValue() !== null ? formatDate(Locale.En, info.getValue()!) : '',
      header: props.t('sample.expectedReadyDate'),
      meta: { toggleable: true, defaultVisible: true },
    }),
  ];

  return sampleColumnsCreator({
    t: props.t,
    columns: { afterIndex: 1, columns },
    hideStopFollowing: props.hideStopFollowing,
  });
};
